"use client";

import { Award, Clock, ShieldCheck, Zap } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const expertiseItems = [{
  icon: Award,
  title: "Dossiers Refusés",
  description: "Là où les banques traditionnelles s'arrêtent, nous commençons. Nous trouvons des solutions créatives pour transformer un refus en approbation."
}, {
  icon: Clock,
  title: "Travailleurs Autonomes",
  description: "Votre réalité financière est unique. Nous maîtrisons les programmes spécifiques qui valorisent vos revenus réels pour maximiser votre prêt."
}, {
  icon: ShieldCheck,
  title: "Préavis de 60 jours",
  description: "Une situation d'urgence nécessite une action immédiate. Nous intervenons rapidement pour protéger votre équité et stabiliser votre dossier."
}, {
  icon: Zap,
  title: "Programme Achat/Location",
  description: "Il est possible d'acheter avec 10% de mise de fonds et un mauvais crédit en achat-location. Le programme vous aide à rétablir votre crédit et accumuler l'autre 10% de mise de fonds manquant pour le rachat."
}];
export default function SolutionsPourDossiersComplexes() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="257596" id="solutions-pour-dossiers-complexes" className="dark bg-background py-24">
      <div className="page-container">
        <div className="text-center mb-16">
          <span className="text-primary font-semibold tracking-widest uppercase text-sm mb-4 block font-default">
            Expertise Hypothécaire
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-foreground font-serif">
            Solutions pour dossiers complexes
          </h2>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {expertiseItems.map((item, i) => <div key={i} data-index={i} className={`relative flex flex-col items-center text-center transition-all duration-700 ease-out hover:-translate-y-[5px] hover:shadow-[0_0_20px_rgba(184,166,121,0.15)] p-6 rounded-md border border-border/50 bg-card/30 backdrop-blur-sm ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              {}
              <span className="absolute top-4 right-4 text-6xl font-bold text-foreground/5 select-none pointer-events-none font-default">
                0{i + 1}
              </span>
              
              <div className="w-16 h-16 rounded-md border border-primary/30 bg-primary/5 flex items-center justify-center mb-6 text-primary shrink-0">
                <item.icon className="w-8 h-8" strokeWidth={1} />
              </div>
              <h3 className="text-[24px] font-semibold text-foreground font-default mb-4">
                {item.title}
              </h3>
              <p className="text-[18px] text-muted-foreground font-default leading-relaxed">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}